<template>
  <footer class="footer">
    <div class="main">
      <div class="article">
        <ul class="list">
          <li>
            <p class="app-hidden">
              <router-link to="/home">{{ $t('nav1') }}</router-link>
            </p>
            <p class="app-hidden">
              <router-link to="/teachers">{{ $t('nav2') }}</router-link>
            </p>
            <p class="app-hidden">
              <router-link to="/system">{{ $t('nav3') }}</router-link>
            </p>
            <p class="app-hidden">
              <router-link to="/channel">{{ $t('nav4') }}</router-link>
            </p>
            <p class="app-hidden">
              <router-link to="/about">{{ $t('nav5') }}</router-link>
            </p>
            <p>
              <a @click="showFaq = true">{{ $t('FAQs') }}</a>
            </p>
            <p>
              <a @click="show = true">{{ $t('TERMS') }}</a>
            </p>
            <p>
              <a @click="show1 = true">{{ $t('PRIVACY_POLICY') }}</a>
            </p>
          </li>
          <li>
            <p class="app-hidden">
              <router-link :to="{ path: '/register', query: { type: 0 } }">{{
                $t('common.student')
              }}</router-link>
            </p>
            <!-- <p><router-link :to="{path: '/register', query: {type: 1}}">{{$t("common.teacher")}}</router-link></p> -->
            <p class="app-hidden">
              <router-link to="/login">{{ $t('common.login') }}</router-link>
            </p>
          </li>
          <li>
            <p>
              {{ $t('CONTACT US') }}
              <span class="app-hidden">
                <a
                  href="https://api.whatsapp.com/send?phone=+85292607280"
                  class="newphone"
                  ><img
                    class="img"
                    src="../assets/icon_phone.png"
                    alt=""
                    style="object-fit: cover"
                /></a>
              </span>
            </p>
            <p><span class="mail">customer@newtontutor.hk</span></p>
            <p>
              <span class="art"></span
              ><span class="art-content">tech@newtontutor.hk</span>
            </p>
            <p class="app-hidden">
              <span class="wechat1"></span>
              <span class="wechat-down"></span>
            </p>
            <p class="app-wechat">
              <a @click="showWechat = !showWechat">
                <div class="app-wechat-code" v-if="showWechat">
                  <div class="wechat-down"></div>
                  <p>{{ $t('common.scanWechat') }}</p>
                </div>
              </a>
            </p>
            <p class="app-email">
              <a href="mailto:customer@newtontutor.hk"></a>
            </p>
            <p class="app-phone">
              <a href="https://api.whatsapp.com/send?phone=+85292607280"></a>
            </p>
          </li>
        </ul>
        <a
          href="https://www.facebook.com/newtonacademictuition"
          target="_blank"
          class="btn-facebook"
        ></a>
        <a
          href="https://www.instagram.com/newtonacademictuition"
          target="_blank"
          class="btn-instagram"
        ></a>
        <a
          href="https://apps.apple.com/cn/app/%E7%89%9B%E5%89%91%E5%AD%A6%E6%9C%AF/id1550299528"
          class="btn-appstore"
          target="_blank"
        ></a>
        <a
          href="https://play.google.com/store/apps/details?id=com.newtonacademic.newtontutors"
          class="btn-googleplay"
          target="_blank"
        ></a>
      </div>
    </div>
    <div class="copyright">
      <p>
        Copyright (Newton Academic Tuition) All Rights Reserved ️&copy; 2021
      </p>
    </div>
    <term :show="show"></term>
    <term1 :show="show1"></term1>
    <term2 :show="showFaq"></term2>
  </footer>
</template>
<script>
import term from '@/components/PopTerm.vue'
import term1 from '@/components/PopTerm1.vue'
import term2 from '@/components/PopTerm2.vue'

export default {
  components: { term, term1, term2 },
  data() {
    return {
      show: false,
      show1: false,
      showFaq: false,
      showWechat: false,
    }
  },
}
</script>
<style lang="scss" scoped>
.newphone {
  width: 46px;
  height: 46px;
  display: inline-block;
  position: relative;
  top: 5px;
  margin-left: 20px;
  background: green;
  border-radius: 50%;
  text-align: center;
  img {
    position: relative;
    top: 8px;
  }
}
.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 775px;
  background: #002147;
  &:before {
    content: '';
    display: block;
    height: 47px;
    background: #99b4a1;
  }
  .article {
    position: relative;
  }
  .btn-facebook,
  .btn-instagram,
  .btn-appstore,
  .btn-googleplay {
    position: absolute;
  }
  .btn-facebook {
    top: 300px;
    right: 331px;
    width: 74px;
    height: 74px;
    background: url(../assets/icon_facebook.png);
  }
  .btn-instagram {
    top: 299px;
    right: 226px;
    width: 76px;
    height: 76px;
    background: url(../assets/icon_instagram.png);
  }

  .btn-appstore,
  .btn-googleplay {
    top: 400px;
    width: 237px;
    height: 74px;
  }
  .btn-appstore {
    // right: 384px;
    right: 168px;
    background: url(../assets/appstore.png);
  }
  .btn-googleplay {
    right: -95px;
    background: url(../assets/googleplay.png);
  }
}
.copyright {
  // &::before{content: ''; display: block; height: 10px; background: #fff;}

  line-height: 70px;
  color: #fff;
  text-align: center;
  font-size: 12px;
}
.main {
  height: 646px;
  background: #57c7d7;
  padding-top: 130px;
}
.list {
  display: flex;
  line-height: 46px;
  color: #fff;
  font-size: 20px;
  li {
    width: 400px;
  }
  a {
    color: #fff;
  }
  .mail,
  .phone,
  .wechat {
    padding-left: 60px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: 0 center;
  }
  .mail {
    background-image: url(../assets/icon_mail.png);
  }
  .phone {
    background-image: url(../assets/icon_phone.png);
  }
  .wechat-down {
    background-image: url(../assets/wechat-down.png);
    display: inline-block;
    width: 100px;
    background-size: cover;
    height: 100px;
  }
  .wechat1 {
    position: relative;
    top: -70px;
    width: 30px;
    height: 30px;
    margin-right: 30px;
    background-image: url(../assets/wechat1.png);
    background-size: cover;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: 0 center;
  }
  .art {
    position: relative;
    top: 4px;
    margin-right: 30px;
    background-image: url(../assets/art.png);
    width: 30px;
    height: 30px;
    background-size: cover;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: 0 center;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .wechat-down {
    background-image: url(../assets/wechat-down.png);
    display: inline-block;
    width: 100px;
    background-size: cover;
    height: 100px;
  }
  .wechat1 {
    position: relative;
    top: -70px;
    width: 30px;
    height: 30px;
    margin-right: 30px;
    background-image: url(../assets/wechat1.png);
    background-size: cover;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: 0 center;
  }
  .phone,
  .app-hidden {
    display: none;
  }
  .art-content {
    position: relative;
    top: -6px;
  }
  .app-hidden {
    display: none;
  }
  .main {
    padding-top: 0;
  }
  .list {
    line-height: normal;
    display: initial;
  }
  .list li {
    padding: 0 20px;
    width: 100%;
    // text-align: center;
  }
  .footer {
    position: initial;
  }
  // .list li:first-child,.list li:nth-child(2) {display: none;}
  .copyright {
    margin: 30px 0;
    line-height: normal;
    word-break: break-all;
    padding: 0 20px;
  }
  .main {
    height: auto;
  }
  .article {
    padding-top: 12px;
    a {
      position: static !important;
      width: auto;
      display: inline-block;
      margin: 10px;
      font-size: 4vw;
    }
    .list {
      a {
        margin: 0;
      }
    }
    li {
      // padding-top: 12px;
      p {
        font-size: 4vw;
        margin-bottom: 12px;
        span {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
  .footer {
    height: auto;
  }
  .copyright {
    margin: 0;
    padding: 20px 10px;
  }
  .app-wechat,
  .app-phone,
  .app-email {
    z-index: 99999;
    display: block;
    position: fixed;
    bottom: 0;
    right: 0;
    border-radius: 5px;
    height: 40px;
    width: 40px;
    margin: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    top: 50%;
    a {
      width: 30px !important;
      height: 30px;
      display: block;
      position: absolute !important;
      top: 5px;
      left: 5px;
      background-image: url(../assets/icon_phone.png);
    }
  }
  .app-email {
    top: calc(50% + 50px);
    a {
      position: relative;
      background-image: url(../assets/icon_mail.png);
      background-size: 100% auto;
      background-repeat: no-repeat;
      top: 8px;
    }
  }
  .app-wechat {
    top: calc(50% - 50px);
    a {
      position: relative;
      background-image: url(../assets/wechat1.png);
    }
  }
  .app-wechat-code {
    position: absolute;
    top: -50px;
    right: 50px;
    width: 200px;
    height: 200px;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99999;
    border-radius: 20px;
    text-align: center;
    // color: #000;
    p {
      margin-top: 20px;
    }
  }
  .app-wechat-code::after {
    position: absolute;
    content: '';
    right: -10px;
    top: 55px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid rgba(0, 0, 0, 0.6);
  }
  .wechat-down {
    display: block;
    margin-top: 20px;
  }
}
</style>
